export class GoogleMapsService {
  constructor() {
    this.geocoder = new google.maps.Geocoder();
    this.maxZoomService = new google.maps.MaxZoomService();
  }

  getMaxZoom(location) {
    const maxZoomService = this.maxZoomService;
    return new Promise(
      function(resolutionFunc, rejectionFunc) {
        maxZoomService.getMaxZoomAtLatLng(location, function(response) {
          if (response.status !== 'OK') {
            rejectionFunc(response.status);
          } else {
            resolutionFunc(response.zoom);
          }
        });
      }
    );
  }

  geocodeAdmin2(location) {
    const geocoder = this.geocoder;
    return new Promise(
      function(resolutionFunc, rejectionFunc) {
        geocoder.geocode({'location': location}, function(results, status) {
          if (status === 'OK') {
            if (results.length > 1) {
              const resultsAdmin2 = results.filter((result) => (result.types.includes("administrative_area_level_2")));
              if (resultsAdmin2.length) {
                resolutionFunc(resultsAdmin2[0].formatted_address);
                return;
              } else {
                const resultsAdmin1 = results.filter((result) => (result.types.includes("administrative_area_level_1")));
                if (resultsAdmin1.length) {
                  resolutionFunc(resultsAdmin1[0].formatted_address);
                  return;
                }
              }
              resolutionFunc(results[0]);
              return;
            }
            resolutionFunc(null);
          } else {
            rejectionFunc(status);
          }
        });
      }
    );
  }
}
